import { Pdf, Plugin, Sdk } from 'src/app/_models/strapi-file';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CmsService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly privateCmsBase = '/develop/v1/cms';
  private readonly publicCmsBase = '/public_develop/v1/cms';


  getPlugins() {
    return this.http.get(`${this.privateCmsBase}/plugins`)
    .pipe(
      map((response: unknown[]) => response.map(plugin => new Plugin(plugin as Record<string, unknown>)))
    );
  }

  getPlugin(id) {
    return this.http.get(`${this.privateCmsBase}/plugins/${id}`)
    .pipe(
      map((plugin: Plugin) => new Plugin(plugin))
    );
  }


  getSdks() {
    return this.http.get(`${this.privateCmsBase}/sdks`)
    .pipe(
      map((response: unknown[]) => response.map(sdk => new Sdk(sdk as Record<string, unknown>)))
    );
  }

  getDocuments() {
    return this.http.get(`${this.publicCmsBase}/docs`)
    .pipe(
      map((response: unknown[]) => response.map(pdf => new Pdf(pdf as Record<string, unknown>)))
    );
  }

  getPrivateFileProxyUrl(url: string): string {
    const query = encodeURIComponent(url || '');
    return `${this.privateCmsBase}/file?url=${query}`;
  }

  getPublicFileProxyUrl(url: string): string {
    const query = encodeURIComponent(url || '');
    return `${this.publicCmsBase}/file?url=${query}`;
  }

  downloadPrivateFile(url: string): Observable<Blob> {
    return this.http.get(this.getPrivateFileProxyUrl(url), {responseType: 'blob'});
  }

  downloadPublicFile(url: string): Observable<Blob> {
    return this.http.get(this.getPublicFileProxyUrl(url), {responseType: 'blob'});
  }

  downloadFile(url: string): Observable<Blob> {
    return this.downloadPublicFile(url);
  }

}
